import { render, staticRenderFns } from "./ProdDivView.vue?vue&type=template&id=95fc82c8&"
import script from "./ProdDivView.vue?vue&type=script&lang=js&"
export * from "./ProdDivView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports